// ---- Composant isolé ----
import React, { useState } from "react";
import { Input } from "antd";

interface HourlyRateCellProps {
  index: number;
  watch: any;
  setValue: any;
}

const HourlyRateCell: React.FC<HourlyRateCellProps> = ({
  index,
  watch,
  setValue,
}) => {
  const isEditing = watch(`hourlyRates.${index}.isEditing`);
  const currentAmount = watch(`hourlyRates.${index}.amount`) ?? 0;
  const updatedAmount = watch(`hourlyRates.${index}.updated_amount`);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const handleConfirm = () => {
    if (updatedAmount !== undefined && updatedAmount < 0) {
      setErrorMsg("Le taux horaire ne peut pas être négatif.");
      return;
    }
    setErrorMsg(null);
    // setValue(`hourlyRates.${index}.amount`, updatedAmount ?? currentAmount);
    setValue(
      `hourlyRates.${index}.updated_amount`,
      updatedAmount ?? currentAmount,
    );
    setValue(`hourlyRates.${index}.isEditing`, false);
  };

  return isEditing ? (
    <div className="d-flex flex-column w-100 gap-1">
      <div className="d-flex align-items-center w-100 gap-2">
        <Input
          type="text"
          inputMode="numeric" // affiche un clavier numérique sur mobile
          pattern="[0-9]*"
          className="form-control form-control-sm border-0 shadow-none bg-transparent p-0 text-end flex-grow-1"
          value={updatedAmount ?? currentAmount}
          onChange={(e) => {
            const val = Number(e.target.value);
            if (isNaN(val)) {
              setErrorMsg("Veuillez entrer un nombre valide.");
              return;
            }
            if (val < 0)
              setErrorMsg("Le taux horaire ne peut pas être négatif.");
            else setErrorMsg(null);
            setValue(`hourlyRates.${index}.updated_amount`, val);
          }}
        />
        <button className="btn btn-sm btn-success ms-2" onClick={handleConfirm}>
          ✓
        </button>
      </div>
      {errorMsg && <small className="text-danger">{errorMsg}</small>}
    </div>
  ) : (
    <div className="d-flex align-items-center gap-4">
      <span className="text-dark">
        {(updatedAmount !== undefined && updatedAmount !== currentAmount
          ? updatedAmount
          : currentAmount
        ).toLocaleString("fr-FR")}{" "}
        F
      </span>
      <i
        className="fas fa-edit text-primary cursor-pointer"
        style={{ cursor: "pointer" }}
        onClick={() => setValue(`hourlyRates.${index}.isEditing`, true)}
      />
    </div>
  );
};

export default HourlyRateCell;
